import { isInPeriode } from './periode';

// Fonction qui va recuperer pour chaque thème les scores de chaque élèves cumulés.
export const getScoresThemeEleves = (classe,active, activePeriode) => {

  
    const scoresParThemeEtEleve = {};
    const evaluationsUniquesParTheme = {}; // Récuperer le nombre total d'éval par thème.
    // Collecter tous les scores pour chaque élève et par thème
    classe.eleves.forEach(eleve => {
      eleve.resultats.forEach(resultat => {
         // Filtrer par date : on ne prend en compte que les résultats dont evalDate est dans la période active
            if (!isInPeriode(resultat.evalDate, activePeriode)) return;
        let themeId= null
        if(active==="theme"){
          // L'ID sera l'id du theme dans le cas où active = "theme"
         themeId = resultat.themeNom;
        } else
        {
           // L'ID sera l'id de la compétence dans le cas où active = "compétence"
             themeId = resultat.competenceNom;
            
        }
        const eleveId = eleve.id;
        if(!resultat.scores || resultat.scores ===0){
          return;
        }
        // Initialiser l'objet pour cet élève et ce thème s'il n'existe pas
        if (!scoresParThemeEtEleve[themeId]) {
          scoresParThemeEtEleve[themeId] = {};
           evaluationsUniquesParTheme[themeId] = new Set();
        }
        if (!scoresParThemeEtEleve[themeId][eleveId]) {
          scoresParThemeEtEleve[themeId][eleveId] = {
            scores: 0,
            count: 0
          };
        }
        // Cumuler les scores pour cet élève pour ce thème
        scoresParThemeEtEleve[themeId][eleveId].scores += parseInt(resultat.scores);
        scoresParThemeEtEleve[themeId][eleveId].count += 1;
        
        // Créer la clé unique pour cette évaluation
        const itemId = resultat.attenduId || resultat.savoirFaireId;
        const evaluationUniqueKey = `${resultat.evalId}_${itemId}_${resultat.competenceId}`;
        
        // Ajouter cette combinaison unique
        evaluationsUniquesParTheme[themeId].add(evaluationUniqueKey);
      
      });
    });
     // Convertir les Sets en nombres
    const totalEvaluationsParTheme = {};
    Object.keys(evaluationsUniquesParTheme).forEach(themeId => {
      totalEvaluationsParTheme[themeId] = evaluationsUniquesParTheme[themeId].size;
    });

   
    // On return les deux.
return { 
  scoresParThemeEtEleve, 
  totalEvaluationsParTheme 
};
    
  }
  
  // On calcul pour chaque Theme ou Compétences la moyenne de chaque élève à ce theme.
 export const getMoyennesThemeEleve = (scoresParThemeEtEleve, classeDetail) => {
    // Calculer la moyenne pour chaque élève par thème et attribuer une couleur

  const moyennesParThemeEtEleve = {};

  Object.keys(scoresParThemeEtEleve).forEach(themeId => {
    moyennesParThemeEtEleve[themeId] = [];
    
    Object.keys(scoresParThemeEtEleve[themeId]).forEach(eleveId => {
      const scores = scoresParThemeEtEleve[themeId][eleveId];
      const totalResults = scores.count;
      
      const moyenne = (scores.scores) / (totalResults); // x3 car c'est le score maximum par résultat
  
      let couleur;
      if (moyenne >= 5.25) couleur = 'rgba(34, 139, 34, 0.95)'; // Vert Plus
      else if (moyenne > 4) couleur = 'rgba(134, 239, 172, 0.95)'; // Vert
      else if (moyenne >= 2.5) couleur = 'rgba(251, 191, 36, 0.95)'; // Orange
      else couleur = 'rgba(239, 68, 68, 0.95)'; // Rouge
  
      moyennesParThemeEtEleve[themeId].push({
        eleveNom: classeDetail.eleves.find(e => e.id.toString() === eleveId).nom + " " + classeDetail.eleves.find(e => e.id.toString() === eleveId).prenom,
        couleur: couleur,
      });
    });
  });
  return moyennesParThemeEtEleve;
  }




export const getChartData = (moyennesParThemeEtEleve, totalEvaluationsParTheme) => {
 
  const chartsData = Object.keys(moyennesParThemeEtEleve).map(themeId => {
    // Initialiser les compteurs pour chaque catégorie de couleur
    const couleurCounts = {
      'Très satisfaisant': [],
      'Satisfaisant': [],
      'Fragile': [],
      'Insuffisant': []
    };

   // Pour la partie moyennesParThemeEtEleve
moyennesParThemeEtEleve[themeId].forEach(eleve => {
  if (eleve.couleur === 'rgba(34, 139, 34, 0.95)') couleurCounts['Très satisfaisant'].push(eleve.eleveNom);
  else if (eleve.couleur === 'rgba(134, 239, 172, 0.95)') couleurCounts['Satisfaisant'].push(eleve.eleveNom);
  else if (eleve.couleur === 'rgba(251, 191, 36, 0.95)') couleurCounts['Fragile'].push(eleve.eleveNom);
  else if (eleve.couleur === 'rgba(239, 68, 68, 0.95)') couleurCounts['Insuffisant'].push(eleve.eleveNom);
});

// Pour le rawData du graphique
const rawData = [
  { 
    label: 'Très satisfaisant', 
    value: couleurCounts['Très satisfaisant'].length, 
    color: 'rgba(34, 139, 34, 0.95)',      // Vert forêt doux avec transparence
    hoverColor: 'rgba(34, 139, 34, 0.9)'   // Plus opaque au survol
  },
  { 
    label: 'Satisfaisant', 
    value: couleurCounts['Satisfaisant'].length, 
    color: 'rgba(134, 239, 172, 0.95)',     // Vert menthe doux
    hoverColor: 'rgba(134, 239, 172, 0.9)' 
  },
  { 
    label: 'Fragile', 
    value: couleurCounts['Fragile'].length, 
    color: 'rgba(251, 191, 36, 0.95)',      // Orange/ambre doux
    hoverColor: 'rgba(251, 191, 36, 0.9)'  
  },
  { 
    label: 'Insuffisant', 
    value: couleurCounts['Insuffisant'].length, 
    color: 'rgba(239, 68, 68, 0.95)',       // Rouge doux (pas agressif)
    hoverColor: 'rgba(239, 68, 68, 0.9)'   
  }
];

    // Filtrer pour ne garder que les valeurs > 0
    const filteredData = rawData.filter(item => item.value > 0);

    // Préparer les données pour le graphique Pie
    const pieData = {
      labels: filteredData.map(item => item.label),
      datasets: [{
        data: filteredData.map(item => item.value),
        backgroundColor: filteredData.map(item => item.color),
        hoverBackgroundColor: filteredData.map(item => item.hoverColor),
        borderWidth: 0,
        spacing: filteredData.length > 1 ? 2 : 0 // Pas d'espacement s'il n'y a qu'une valeur
      }]
    };

    // Options de tooltip spécifiques à ce graphique
    const tooltipOptions = {
      responsive: true,
      maintainAspectRatio: false,
      cutout: '65%',
      plugins: {
        tooltip: {
          enabled: true,
          backgroundColor: 'rgba(31, 41, 55, 0.95)',
          padding: 12,
          cornerRadius: 8,
          titleFont: {
            size: 14,
            weight: 'bold'
          },
          bodyFont: {
            size: 12
          },
          callbacks: {
            label: function(context) {
              const label = context.label;
              const nomsEleves = couleurCounts[label];
              
              // Si la valeur n'existe pas dans couleurCounts, retourner un message approprié
              if (!nomsEleves) {
                return `0 élève`;
              }
              
              const labelLines = [`${nomsEleves.length} élève${nomsEleves.length > 1 ? 's' : ''}`];
              
              // Ajouter les noms des élèves
              for (let i = 0; i < nomsEleves.length; i += 2) {
                let line = '• ' + nomsEleves[i];
                if (nomsEleves[i + 1]) {
                  line += ', ' + nomsEleves[i + 1];
                }
                labelLines.push(line);
              }
              
              return labelLines;
            }
          }
        },
        legend: {
          display: false
        }
      }
    };

 
    return {
      themeId: themeId,
      data: pieData,
      options: tooltipOptions,
      couleurCounts: couleurCounts,
       // Ajouter les statistiques pour un accès facile
      stats: {
        tresSatisfaisant: couleurCounts['Très satisfaisant'].length,
        satisfaisant: couleurCounts['Satisfaisant'].length,
        fragile: couleurCounts['Fragile'].length,
        insuffisant: couleurCounts['Insuffisant'].length,
        total: moyennesParThemeEtEleve[themeId].length
      },
     totalEvaluations: totalEvaluationsParTheme ? totalEvaluationsParTheme[themeId] || 0 : 0,
    };
    
  });

  
  return chartsData;
}


// Retourne pour chaque thème les pourcentages et listes d'élèves par niveau de maîtrise.
// Input : scoresParThemeEtEleve (sortie de getScoresThemeEleves) + classeDetail (pour nom/prenom)
export const getThemeProgressData = (scoresParThemeEtEleve, classeDetail) => {
  const result = {};

  Object.keys(scoresParThemeEtEleve).forEach(themeId => {
    const elevesData = scoresParThemeEtEleve[themeId];
    const categories = {
      aBesoins: [],
      fragile: [],
      satisfaisant: [],
      tresSatisfaisant: [],
    };

    Object.keys(elevesData).forEach(eleveId => {
      const { scores, count } = elevesData[eleveId];
      const moyenne = scores / count;
      const eleve = classeDetail.eleves.find(e => e.id.toString() === eleveId);
      if (!eleve) return;

      const eleveObj = { id: eleve.id, nom: eleve.nom, prenom: eleve.prenom };

      if (moyenne >= 5.25) categories.tresSatisfaisant.push(eleveObj);
      else if (moyenne > 4) categories.satisfaisant.push(eleveObj);
      else if (moyenne >= 2.5) categories.fragile.push(eleveObj);
      else categories.aBesoins.push(eleveObj);
    });

    const total = Object.keys(elevesData).length;

    result[themeId] = {
      hasData: total > 0,
      total,
      aBesoins: { percent: total ? Math.round((categories.aBesoins.length / total) * 100) : 0, eleves: categories.aBesoins },
      fragile: { percent: total ? Math.round((categories.fragile.length / total) * 100) : 0, eleves: categories.fragile },
      satisfaisant: { percent: total ? Math.round((categories.satisfaisant.length / total) * 100) : 0, eleves: categories.satisfaisant },
      tresSatisfaisant: { percent: total ? Math.round((categories.tresSatisfaisant.length / total) * 100) : 0, eleves: categories.tresSatisfaisant },
    };
  });

  return result;
};

// Convertit la sortie de getColorThemeEvalNat en progressData pour ThemeClassePieChart
export const getThemeProgressDataFromEvalNat = (colorThemeData) => {
  const result = {};
  const colorToLevel = {
    'rgba(239, 68, 68, 0.95)': 'aBesoins',
    'rgba(251, 191, 36, 0.95)': 'fragile',
    'rgba(134, 239, 172, 0.95)': 'satisfaisant',
    'rgba(34, 139, 34, 0.95)': 'tresSatisfaisant',
  };

  Object.keys(colorThemeData).forEach(themeName => {
    const eleves = colorThemeData[themeName];
    const categories = { aBesoins: [], fragile: [], satisfaisant: [], tresSatisfaisant: [] };

    eleves.forEach(({ eleveNom, couleur }) => {
      const level = colorToLevel[couleur] || 'fragile';
      const parts = eleveNom?.split(' ') || [];
      const nom = parts[0] || '';
      const prenom = parts.slice(1).join(' ') || '';
      categories[level].push({ id: eleveNom, nom, prenom });
    });

    const total = eleves.length;
    result[themeName] = {
      hasData: total > 0,
      total,
      aBesoins: { percent: total ? Math.round((categories.aBesoins.length / total) * 100) : 0, eleves: categories.aBesoins },
      fragile: { percent: total ? Math.round((categories.fragile.length / total) * 100) : 0, eleves: categories.fragile },
      satisfaisant: { percent: total ? Math.round((categories.satisfaisant.length / total) * 100) : 0, eleves: categories.satisfaisant },
      tresSatisfaisant: { percent: total ? Math.round((categories.tresSatisfaisant.length / total) * 100) : 0, eleves: categories.tresSatisfaisant },
    };
  });

  return result;
};

// PLUS UTILISÉE depuis le 03/10/2026 : son seul appelant, AlertesEleves, est
// supprimé (le tableau de bord ne montre plus que « L'analyse de TanoEd »).
// À supprimer une fois la nouvelle page confirmée.
export const getAlertesEleves = (classeDetail, activePeriode) => {
  if (!classeDetail?.eleves || classeDetail.eleves.length === 0) {
    return { enDifficulte: [], excellents: [], moyenneClasse: 0 };
  }
  const MAX_SCORE = 6;
  const elevesStats = [];

  classeDetail.eleves.forEach(eleve => {
    const resultats = eleve.resultats.filter(r => {
      if (!r.scores || r.scores === 0) return false;
      return isInPeriode(r.evalDate, activePeriode);
    });
    if (resultats.length === 0) return;

    const somme = resultats.reduce((acc, r) => acc + r.scores, 0);
    const moyenne = Math.round((somme / resultats.length / MAX_SCORE) * 100);

    const evalGroups = {};
    resultats.forEach(r => {
      if (!evalGroups[r.evalId]) evalGroups[r.evalId] = { scores: [], date: r.evalDate };
      evalGroups[r.evalId].scores.push(r.scores);
    });

    const evalsChronologiques = Object.values(evalGroups)
      .map(g => ({
        date: g.date,
        moyenne: Math.round((g.scores.reduce((a, b) => a + b, 0) / g.scores.length / MAX_SCORE) * 100)
      }))
      .sort((a, b) => new Date(a.date) - new Date(b.date));

    const lastEvals = evalsChronologiques.slice(-4).map(e => e.moyenne);

    let trend = 'stable';
    if (lastEvals.length >= 3) {
      const mid = Math.floor(lastEvals.length / 2);
      const firstHalf = lastEvals.slice(0, mid).reduce((a, b) => a + b, 0) / mid;
      const secondHalf = lastEvals.slice(mid).reduce((a, b) => a + b, 0) / (lastEvals.length - mid);
      if (secondHalf - firstHalf > 5) trend = 'up';
      else if (firstHalf - secondHalf > 5) trend = 'down';
    }

    elevesStats.push({
      id: eleve.id,
      nom: eleve.eleve_gar_nom || eleve.nom,
      prenom: eleve.eleve_gar_prenom || eleve.prenom,
      moyenne, nbResultats: resultats.length, lastEvals, trend,
    });
  });

  if (elevesStats.length === 0) {
    return { enDifficulte: [], excellents: [], moyenneClasse: 0 };
  }

  const moyenneClasse = Math.round(elevesStats.reduce((acc, e) => acc + e.moyenne, 0) / elevesStats.length);
  elevesStats.forEach(e => {
    e.ecart = e.moyenne - moyenneClasse;
    e.moyenneClasse = moyenneClasse;
  });

  const enDifficulte = elevesStats
    .filter(e => e.ecart < -15 || e.moyenne < 35)
    .sort((a, b) => a.ecart - b.ecart);

  const excellents = elevesStats
    .filter(e => e.ecart > 15 || e.moyenne > 75)
    .sort((a, b) => b.ecart - a.ecart);

  return { enDifficulte, excellents, moyenneClasse };
};